function formatPrice(price) {
  return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function formatGram(number) {
  if (Number.isInteger(number)) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return number.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}

export { formatPrice, formatGram };
